<template>
  <div class="heading-container">
        <div class="step-container">
            <h2 class="step">{{step}}</h2>
        </div>
        <h2 class="heading">{{heading}}</h2>
    </div>
</template>

<script>
export default {
    name: 'section-heading',
    props: ['step', 'heading'],
};
</script>

<style scoped lang='scss'>
  .heading-container {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .step-container {
          border: 1px solid var(--global-primary-brand);
          color: var(--global-primary-brand);
          width: 40px;
          height: 40px;
          border-radius: 20px;
          text-align: center;
          margin-right: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          .step {
              margin: 0;
          }
      }
      .heading {
          margin: 0;
      }
  }
</style>